<template>
  <vx-tooltip :text="$t('attended_transfer')" position="bottom">
    <vs-button
      class="includeIcon includeIconOnly"
      color="success"
      type="border"
      @click="process">
      <i class="c-icon-attended-transfer"></i>
    </vs-button>
  </vx-tooltip>
</template>

<script>
import Cti from '@/models/Cti'

export default {
  name: 'CtiAttendedTransfer',
  props: {
    server: {
      required: true
    },
    isDisplay: {
      default: false
    }
  },
  computed: {
    phoneNumber () {
      return this.$store.getters.phoneNumber
    },
    sipExtension () {
      return this.$store.getters.sipExtension
    }
  },
  methods: {
    process () {
      if (this.isDisplay) {
        return
      }

      if (this.phoneNumber === null || this.phoneNumber.toString().length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Phone Number is Required.',
          color:'danger',
          position:'top-right'
        })
        return
      }

      if (this.sipExtension === null || this.sipExtension.toString().length <= 0) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Ongoing Call is Needed.',
          color:'danger',
          position:'top-right'
        })
        return
      }

      const data = {
        callextension: this.sipExtension,
        channel: this.phoneNumber
      }

      try {
        Cti.attendedTransfer(this.server.domain, data)
        this.$vs.notify({
          title:'CTI Notice',
          text:`${this.phoneNumber} 으로 돌려 주기 완료`,
          color:'success',
          position:'top-right'
        })
      } catch (e) {
        this.$vs.notify({
          title:'CTI Notice',
          text:'Attended Transfer Error',
          color:'danger',
          position:'top-right'
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
